import { motion } from 'motion/react'
import { ArrowRight } from 'lucide-react'
import { SectionHeading } from '../common/SectionHeading'
import { steps } from '../../utils/landingContent'
import type { LandingCopy } from '../../models/LandingPage'

type HowItWorksSectionProps = {
  copy: LandingCopy
  reveal: object
}

export function HowItWorksSection({ copy, reveal }: HowItWorksSectionProps) {
  return <section id="how" className="section how"><div className="container"><motion.div {...reveal}><SectionHeading eyebrow="01 — HOW IT WORKS" title={copy.howTitle} sub={copy.howSub}/></motion.div><div className="steps">{steps.map(({ title, description, Icon },i)=><motion.article key={title} {...reveal} transition={{duration:.55,delay:i*.06}}><div className="step-number">0{i+1}</div><div className="step-icon"><Icon size={22}/></div><h3>{title}</h3><p>{description}</p>{i<steps.length-1&&<ArrowRight className="step-arrow"/>}</motion.article>)}</div></div></section>
}
